import { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import moment from "moment";

import ScrollToTop from "./ScrollToTop";
import GoToTopButton from "./GoToTopButton";
import StandaloneRouteGate from "./StandaloneRouteGate";

import UnAuthView, { MobileUnAuthView } from "./UnAuth";
import AuthView, {
  NoAuthEmailUsernameView,
  MobileAuthView,
  MobileNoAuthEmailUsernameView,
} from "./Auth";
import Navbar from "../components/Desktop/Navbar";
import NavbarMobile from "../components/Mobile/Navbar";
import NavbarMobileMenu from "../components/Mobile/NavbarMenu";
import Footer from "../components/Desktop/Footer";
import FooterMobile from "../components/Mobile/Footer";
import { useCompleteSignIn } from "../hooks/authhooks";
import { useResource } from "../contexts/appcontext";
import LoadingScreen from "../components/Desktop/LoadingScreen";
import PromoModal from "../molecules/promo/PromoModal";
import { FilterType, SearchFilterOptionType } from "../data/types";
import { initializePendo } from "../utils/pendo";
import { getUIDFromAccessToken } from "../utils/helpers";
import config from "../config";

var appStage = config?.env;

const HomeCookRouter = () => {
  const { user, reloadUser } = useCompleteSignIn();
  const { globalFilter } = useResource();
  const [searchTerm, changeSearchTerm] = useState<string>("");
  const [currentFilter, setCurrentFilter] = useState<FilterType>(globalFilter);
  const [signInModalIsOpen, setSignInModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const [messagesOpen, setMessagesOpen] = useState(false);

  const loggedinUsername = user?.username ?? "";
  const loggedinUid = user?.uid ?? "";

  const [width, setWidth] = useState(window.innerWidth);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  const isMobile = width < 1024;

  useEffect(() => {
    const checkUserStatus = async () => {
      setLoading(true); // Set loading to true when starting to reload user
      await reloadUser(); // Wait for the user state to be reloaded
      setLoading(false); // Set loading to false after the user is loaded
    };

    checkUserStatus();
    setCurrentFilter(
      user && user?.state
        ? { state: user.state, active: false, resourceType: "kitchen" }
        : globalFilter,
    );

    var accountId = loggedinUsername
      ? `${appStage}_resource_pantry_signedup_users`
      : `${appStage}_resource_pantry_anonymous_users`;
    var visitorId = loggedinUsername
      ? loggedinUsername
      : localStorage.getItem("visitorId");

    if (!visitorId) {
      var login_token: any = localStorage.getItem("login_token");
      var token_uid: string = getUIDFromAccessToken(login_token);

      visitorId = login_token && token_uid ? token_uid : moment().format();
      accountId =
        login_token && token_uid
          ? `${appStage}_resource_pantry_auth_users`
          : accountId;

      localStorage.setItem("visitorId", (visitorId as string) || "");
    }

    if (visitorId && accountId) {
      initializePendo(visitorId, accountId);
    }
    // eslint-disable-next-line
  }, [user, loggedinUid, loggedinUsername]);

  const searchFilterOptions: SearchFilterOptionType = {
    searchTerm,
    currentFilter,
    signInModalIsOpen,
    messagesOpen,
    changeSearchTerm,
    setCurrentFilter,
    setSignInModalIsOpen,
    setMessagesOpen,
  };

  const [isMobileNavbarMenuOpen, setIsMobileNavbarMenuOpen] = useState(false);

  return (
    <Router basename="/">
      <ScrollToTop />
      <GoToTopButton />

      <StandaloneRouteGate>
        {isMobile ? (
          <NavbarMobile setIsMobileNavbarMenuOpen={setIsMobileNavbarMenuOpen} isMobileNavbarMenuOpen={isMobileNavbarMenuOpen} />
        ) : (
          <Navbar />
        )}

        {isMobile && (
          <NavbarMobileMenu isMobileNavbarMenuOpen={isMobileNavbarMenuOpen} setIsMobileNavbarMenuOpen={setIsMobileNavbarMenuOpen} />
        )}
      </StandaloneRouteGate>

      {!(isMobile && isMobileNavbarMenuOpen) && (
        <>
          {loading ? (
            <LoadingScreen />
          ) : loggedinUid && loggedinUsername ? (
            isMobile ? (
              <MobileAuthView searchFilterOptions={searchFilterOptions} />
            ) : (
              <AuthView searchFilterOptions={searchFilterOptions} />
            )
          ) : loggedinUid && !loggedinUsername ? (
            isMobile ? (
              <MobileNoAuthEmailUsernameView
                searchFilterOptions={searchFilterOptions}
              />
            ) : (
              <NoAuthEmailUsernameView searchFilterOptions={searchFilterOptions} />
            )
          ) : isMobile ? (
            <MobileUnAuthView searchFilterOptions={searchFilterOptions} />
          ) : (
            <UnAuthView searchFilterOptions={searchFilterOptions} />
          )}

          <StandaloneRouteGate>
            {isMobile ? <FooterMobile /> : <Footer />}
          </StandaloneRouteGate>
        </>
      )}

      <PromoModal isReady={!loading} />
    </Router>
  );
};

export default HomeCookRouter;
